import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { EzazSinglePageImageGallery } from "../../../components/image-gallery/ezaz-singlepage-gallery";

export const EzazSinglePageModalData = () => {
  const { ezazSinglePageModalState } = useContext<IAppContextState | any>(
    AppContext
  );
  const [isOpenEzazSinglePageModal, setOpenEzazSinglePageModal] =
    ezazSinglePageModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenEzazSinglePageModal}
      onClose={() => setOpenEzazSinglePageModal(false)}
    >
      <Modal.Header>Card style Single Page Portfolio</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <EzazSinglePageImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name:{" "}
                <span className="text-gray-600">Single Page Portfolio</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="red" className="me-2 my-1">
                  HTML
                </Badge>
                <Badge color="yellow" className="me-2 my-1">
                  jQuery
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    This is my another portfolio website built on a single HTML
                    page, with Interfaces like SPA framework based applications.
                  </p>
                  <ul className="list-disc mt-4 ms-5">
                    <li>This website is fully responsive.</li>
                    <li>
                      Used javaScript and jQuery for dynamic UI functionalities.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://3z4z.netlify.app/"
                className="text-gray-800 hover:text-gray-950 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
